import React, { Fragment } from "react";
import { NavItem, Dropdown, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavLink from "react-bootstrap/NavLink";
import { useEffect } from "react";
import { addRequest, removeRequest } from "../../redux/actions";
import { withRouter } from "react-router-dom";

const LanguageSelector = (props) => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const availableLanguages = useSelector(
    (state) => state.main.availableLanguages
  );

  const changeLanguage = (lang) => {
    if (i18n.language !== lang.locale) {
      dispatch(
        addRequest("LOADING_LANG_TRANSATION", "Loading translations...")
      );
      localStorage.setItem("lang", JSON.stringify(lang));
      document.body.classList.remove("rtl");
      document.body.classList.remove("ltr");
      document.body.classList.add(lang["direction"]);
      props.setSelectedLang(lang);
      const newUrl = window.location.pathname.replaceAt(0, `/${lang.locale}/`);
      props.history.push(newUrl);
    }
  };

  useEffect(() => {
    dispatch(addRequest("LOADING_LANG_TRANSATION", "Loading translations..."));
    i18n.changeLanguage(props.selectedLang.locale).then((t) => {
      dispatch(removeRequest("LOADING_LANG_TRANSATION"));
    });
  }, [dispatch, i18n, props.selectedLang]);

  return (
    <Fragment>
      {Object.keys(availableLanguages).length > 1 ? (
        <Dropdown as={NavItem}>
          <Dropdown.Toggle as={NavLink}>
            {t(
              props.selectedLang["name"]
                ? props.selectedLang["name"]
                : "Language"
            )}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-top-100 shadow animated--grow-in">
            {Object.keys(availableLanguages).map((key) => {
              if (
                props.selectedLang["locale"] !== availableLanguages[key].locale
              ) {
                return (
                  <Dropdown.Item
                    key={key}
                    as={Button}
                    onClick={() => {
                      props.setExpanded(false);
                      changeLanguage(availableLanguages[key]);
                    }}
                  >
                    {t(availableLanguages[key].name)}
                  </Dropdown.Item>
                );
              } else {
                return null;
              }
            })}
          </Dropdown.Menu>
        </Dropdown>
      ) : null}
    </Fragment>
  );
};

export default withRouter(LanguageSelector);
